import { render, staticRenderFns } from "./Salary2.vue?vue&type=template&id=3db5a5bd&"
import script from "./Salary2.vue?vue&type=script&lang=js&"
export * from "./Salary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports